const 
	CREATE_NEW_EVENT = 1,
	UPDATE_EXISTING_EVENT = 2;

const 
	ZOOM_FACTORS = [
		{label: _('2 Hours'), value: 6.4},
		{label: _('6 Hours'), value: 8.4},
		{label: _('12 Hours'), value: 10},
		{label: _('24 Hours'), value: 12},
		{label: _('2 Days'), value: 15},
		{label: _('7 Days'), value: 20},
		{label: _('14 Days'), value: 25},
		{label: _('40 Days'), value: 30}
	],
	DEFAULT_ZOOM = 3;

const
	MIN_PANNING_VELOCITY = 70,
	MAX_PANNING_VELOCITY = 500,
	PANNING_ACCELERATION = 60,
	PANNING_DECELERATION = 40;

const SNAP_DISTANCE = 5 * 60 * 1000; // 5 mins in milliseconds
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
const DOWNLOAD_TRIGGER_MARGIN = 2 * MILLISECONDS_PER_DAY; // 2 DAYS
const DOWNLOAD_BUFFER = 10 * MILLISECONDS_PER_DAY  // 10 DAYS

/**
 * Lightweight list for managing timeline instances.
 */
class SimpleTimelineList {
	constructor() { this._items = []; }
	get items() { return this._items; }
	get first() { return this._items[0]; }
	get length() { return this._items.length; }
	get isNotEmpty() { return this._items.length > 0; }
	addItem(item) { this._items.push(item); }
	clear() { this._items.length = 0; }
	forEach(fn) { this._items.forEach(fn); }
}

class TimelineManager {
	constructor (display) {
		this.display = typeof display == 'undefined' ? Timeline.STANDALONE : display;

		this._elem = null;
		this._onTimelineAdded = null;
		this._timelineIds = [];
		this.withActivity = CREATE_NEW_EVENT;

		this.gotoDatePicker = new DatePicker('goto-date-picker');
		this.gotoDatePicker.setHideOnSelect(true);
		this.gotoDatePicker.setCallbackFunction(
			() => {this.goToDate(this.gotoDatePicker.getUTC() + 60000*60*12)}
		);

		this.startDatePicker = new DatePicker('start-date-picker');
		this.startDatePicker.setHideOnSelect(true);
		// this.startDatePicker.setCallbackFunction(this.onStartTimeChanged, this);

		// this.endDatePicker = new DatePicker('end-date-picker');
		// this.endDatePicker.setHideOnSelect(true);
		// this.endDatePicker.setCallbackFunction(this.onEndTimeChanged, this);

		this.startTimePicker = new TimePicker('start-time-picker');
		// this.startTimePicker.setCloseCB(this.onStartTimeChanged, this);

		// this.endTimePicker = new TimePicker('end-time-picker');
		// this.endTimePicker.setCloseCB(this.onEndTimeChanged, this);

		// this.groupStartDatePicker = new DatePicker();
		// this.groupStartDatePicker.setHideOnSelect(true);
		// this.groupStartDatePicker.setCallbackFunction(this.onGroupStartChanged, this);

		// this.groupStartTimePicker = new TimePicker();
		// this.groupStartTimePicker.setCloseCB(this.onGroupStartChanged, this);

		this.colourPicker = new ColorPicker2('activity-color-picker');
		this.colourPicker.onChange(this.updateActivityPreview, this);

		this.splitDialog = Dialog.Modal('repeat-events', _("Repeat Events"), SMALL, null, [
			UI.div(
				'flex p-3 gap-3 flex-col',
				[
					UI.btn('', _("UPDATE ALL EVENTS"), { 'click': () => this.splitDialog.affirm(1) }),
					UI.btn('', _("UPDATE ONLY THIS EVENT"), { 'click': () => this.splitDialog.affirm(2) }),
					UI.btn('', _("UPDATE THIS AND LATER EVENTS"), { 'click': () => this.splitDialog.affirm(3) })
				]
			)
		]);

		this.activityEditDialog = Dialog.Modal('activity-details', _("Activity Properties"), LARGE, _("SAVE"));
		this.linkResourceList = new LinkResourceList(this.activityEditDialog);
		this.zoomPicker = UI.select(ZOOM_FACTORS.map((zf, i) => UI.option(zf.label, i)), {
			'change': this.selectZoom.bind(this)
		}, {
			'data-tip': 'above',
			'aria-label': _("Select time period to fit in the timeline view"),
			'id':'timeline-zoom-picker'
		});

		let stickBar = ge('sticky-bar');

		stickBar.appendChild(
			UI.div('', [
				UI.inputGrp([
					UI.priIconBtn(
						'zoom-out', 16, 
						{'click': this.zoomOut.bind(this)},
						{
							'id': 'timeline-zoom-out',
							'data-tip': 'above',
							'aria-label': _('Zoom out')
						}
					),
					UI.priIconBtn(
						'zoom-in', 16,
						{'click': this.zoomIn.bind(this)},
						{
							'id': 'timeline-zoom-in',
							'data-tip': 'above',
							'aria-label': _('Zoom In')
						}
					),
					this.zoomPicker
				]),
				UI.div('inline px-1', [
					UI.inputGrp([
						UI.priIconBtn(
							'angle-double-left', 16,
							{'click': this.prevWeek.bind(this)},
							{
								'aria-label': _('Move to previous week'),
								'data-tip': 'above'
							}
						),
						UI.priIconBtn(
							'angle-left', 16,
							{'click': this.prevDay.bind(this)},
							{
								'aria-label': _('Move to previous day'),
								'data-tip': 'above'
							}
						),
						this.gotoDatePicker.getInputElem(),
						UI.priIconBtn(
							'angle-right', 16,
							{'click': this.nextDay.bind(this)},
							{
								'aria-label': _('Move to next day'),
								'data-tip': 'above'
							}
						),
						UI.priIconBtn(
							'angle-double-right', 16,
							{'click': this.nextWeek.bind(this)},
							{
								'aria-label': _('Move to next week'),
								'data-tip': 'above'
							}
						)
					])
				], null, {'id':'timeline-date-controls'})
			])
		);
		
		if (nav.page == 'timeline' || nav.page == 'layers') {
			if (nav.entityType == Nav.CIRCLE) {
				if (nav.unit.isAdmin) {
					stickBar.appendChild(
						UI.priIconBtn('layer-setting', 24, {
							'click': () => { manageLayers.open(this.timelines.first) }
						})
					);
				}
			}
			else if(nav.entityType == Nav.USER || nav.unit.isAdmin) {
				stickBar.appendChild(
					UI.priIconBtn('layer-plus', 20, {
						'click': () => this.newLayer()
					}, {
						'data-tip': 'above',
						'aria-label': _("Add new layer")
					})
				)
			}
		}
		

		//  Start UI construction ----------------------------------
		if (document.cookie.match(/view-layer-ctrl=1/)) document.body.classList.add('flip-on');

		this._timelinesElem = null;
		
		this.activitySearchDialog = Dialog.Modal('activity-search', _("Activity Search"), X_LARGE);
		this.activitySearchDialog.head = UI.span('hint', [
			this.activitySearchText = UI.text(null, {
				'keyup': this.getActivities.bind(this)
			}, {
				'placeholder': _("Search text or name of new activity"),
			})
		]);
		this.activitySearchDialog.body = this.activitySearchContainer = UI.div('activity-search-container');

		this.selectedActivity = null;
		this.activityEditDialog.body = [
			this.activityPreview = UI.div('flex p-3 gap-3', [
				UI.div('flex-0', [
					UI.div('graphic-edit-view', [
						this.activityEditGraphic = UI.img(),
						this.activityGraphicOverlay = UI.div(null, null, {
							'click': this.changeActivityGraphic.bind(this)
						})
					])
				]),
				UI.div('flex-1 flex flex-col gap-3', [
					this.activityEditText = UI.text(null,
						{ 'keyup': this.updateActivityPreview.bind(this) }
					),
					UI.div('', this.colourPicker.getElem())
				])
			]),
			this.linkResourceList.elem
		];
		this.activityEditDialog.foot = this.copyActivityLabel = UI.div('p-2', [
			UI.label(
				[
					this.copyActivityChk = UI.chk(),
					UI.span('ms-2 text-white', _("Make a new copy"))
				]
			)
		]);

		this.repeatDialog = Dialog.Modal('repeat', null, MEDIUM, _("SAVE REPEAT"));

		this.moveCopyDialog = Dialog.Modal('copy-move', null, MEDIUM, null ,[
			UI.p(null, 'Start date - time:'),
			UI.p(null, [
				this.startDatePicker.getInputElem(),
				this.startTimePicker.getInputElem()
			]),
			UI.p(null, 'Layer:'),
			UI.p(null, [
				this.layerSelect = UI.select()
			])
		]);

		this.selectEventChk = UI.chk();
		onEv(this.selectEventChk, 'change', this.selectInstance.bind(this, null));

		this.eventPopup = UI.div('eventPopUp hide', [
				this.eventDetail = UI.div('eventDetails', [
					this.popupGraphic = UI.img('activityGraphic'),
					UI.div(null, [
						this.popupName = UI.span()
					]),
					UI.div(null, [
						this.popupGroupIcon = UI.span('icon hide', '<i class="i-rg i-group"></i>'),
						this.popupRepeatIcon = UI.span('icon hide', '<i class="i-rg i-repeat"></i>'),
						this.popupLinkIcon = UI.span('icon hide', '<i class="i-rg i-resources"></i>')
					]),
					UI.div('event-select', this.selectEventChk),
				]),
				this.eventButtons = UI.div('eventButtons', [
					this.editActivityButton = UI.priIconBtn('edit', 18, {
						'click': this.onEditActivityClicked.bind(this)
					}, {
						'data-tip': 'above',
						'aria-label': 'Edit the events activity'
					}),
					this.eventRepeatButton = UI.priIconBtn('repeat', 18, {
						'click': this.repeatEvent.bind(this)
					}, {
						'data-tip': 'above',
						'aria-label': 'Repeat this event'
					}),
					this.moveEventButton = UI.priIconBtn('move', 18, {
						'click': this.moveEvent.bind(this)
					}, {
						'data-tip': 'above',
						'aria-label': 'Move this event'
					}),
					UI.priIconBtn('copy', 18, {
						'click': this.copyEvent.bind(this)
					}, {
						'data-tip': 'above',
						'aria-label': 'Copy this event'
					}),
					UI.priIconBtn('delete', 18, {
						'click': this.deleteEvent.bind(this)
					}, {
						'data-tip': 'above',
						'aria-label': 'Delete this event'
					})
				])
			]
		);

		document.body.appendChild(this.eventPopup);

		onEv(document, 'primaryDataInvalid', this.refreshData.bind(this));

		// ------------------------------- End UI construction -------------------------------


		this.zoomPause = null;

		// number of days viewable in the with of the timeline
		let cookieZoom = getCookie('tl-zoom');
		this.zoomPicker.value = cookieZoom === null ? DEFAULT_ZOOM : cookieZoom;
		this.zoomFactor = ZOOM_FACTORS[this.zoomPicker.value].value;

		let cookieTime = getCookie('tl-time');
		if (cookieTime !== null) {
			this.originTime = parseInt(cookieTime);
		} else {
			let now = new Date();
			this.originTime = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0);
		}

		this.targetTime = this.originTime;
		this.panVelocity = 0;
		this.panStopDist = 0;

		this.millisecondPerPixel = 1;
		this.datumFraction = 0.5;
		this.memoryTimeA = null;
		this.memoryTimeB = null;

		this.timelines = new SimpleTimelineList();
		this._layers = [];
		this._layerIds = [];
		this._events = [];
		this._eventIds = [];

		this.activities = new ActivityList();
		this.activitySearchResult = [];

		this.activeLayer = null;
		this.activeInstance = null;

		this.selection = new TimelineItemList('startTime', 'endTime');
		this.selectionMgr = new SelectionMgr(this.selection.items);


		this.selectionMgr.addButton(UI.priIconBtn('repeat', 18, {'click': this.repeatSelection.bind(this)}));
		this.selectionMgr.addButton(UI.priIconBtn('move', 18, {'click': this.moveSelection.bind(this)}));
		this.selectionMgr.addButton(UI.priIconBtn('copy', 18, {'click': this.copySelection.bind(this)}));
		this.selectionMgr.addButton(UI.priIconBtn('delete', 18, {'click': this.deleteSelection.bind(this)}));
		this.selectionMgr.clearFunction = this.clearSelection.bind(this);

		this.lastWidth = 0;
		this.resizing = false;
		this._ticker = null;
		this._skipTick = false;
		this._skips = 0;
	}

	/**
	 * Initialize with a DOM element for standalone mode.
	 * Sets up the timeline container, handles, indicator line, resize observer, and starts data fetch.
	 */
	init(elem) {
		this._elem = elem;

		this._timelinesElem = UI.div('timeline-container norm');

		this._elem.appendChild(this._timelinesElem);

		progress(this._elem);

		this._onTimelineAdded = (timeline) => {
			this._timelinesElem.appendChild(timeline.rowElem);
			timeline.initContainer(this._elem);
		};

		this.setWidth(elem.offsetWidth);

		if (typeof ResizeObserver !== 'undefined') {
			this.resizeObserver = new ResizeObserver(this.resize.bind(this));
			this.resizeObserver.observe(elem);
		} else {
			onEv(window, 'resize', this.resize.bind(this));
		}

		this.fetchData();
	}

	/**
	 * Set the render width for scale calculation.
	 * Called by init() or by a TimelineWidget when it knows its content width.
	 */
	setWidth(width) {
		if (!width) return;
		this.lastWidth = width;
		this.millisecondPerPixel = (MILLISECONDS_PER_DAY * this.getDaysInView()) / width;
		this.onScaleChange();
	}

	/**
	 * Set which timeline IDs to fetch. Empty array means fetch default for the current entity.
	 */
	setTimelineIds(ids) {
		this._timelineIds = ids || [];
	}

	/**
	 * Trigger initial data fetch.
	 */
	fetchData() {
		this.getTimelineData();
	}

	get viewStartMilliseconds () {
		let totalMs = this.getDaysInView() * MILLISECONDS_PER_DAY;
		return this.originTime - this.datumFraction * totalMs;
	}

	get viewEndMilliseconds () {
		return this.viewStartMilliseconds + this.getDaysInView() * MILLISECONDS_PER_DAY;
	}


	onActivitySelected(activity, suggestion) {
		this.activitySearchDialog.close();
		this.activitySearchText.value = '';
		
		if (suggestion) {
			this.loadActivityForm(activity);
		}
		else {
			activity = this.activities.addActivity(activity);
			this.activeLayer.newEvent(activity);
		}
	}

	onEditActivityClicked () {
		if (!this.activeInstance) return;
		this.withActivity = UPDATE_EXISTING_EVENT;
		this.loadActivityForm(this.activeInstance.event.activity);
	}

	loadActivityForm (activity) {
		this.copyActivityLabel.style.visibility = this.withActivity === CREATE_NEW_EVENT ? 'hidden' : 'visible';
		this.copyActivityChk.checked = false;
		
		this.activityEditDialog.open(
			this.saveActivity.bind(this),
			this.cancelActivity.bind(this)
		).loading();
		this.selectedActivity = activity;
		this.activityEditText.value = activity.text;
		this.colourPicker.HEX = activity.color;
		this.linkResourceList.getData(activity, this.activeLayer);
		this.updateActivityPreview();
	}

	saveActivity() {
		let activity;
		if (this.copyActivityChk.checked) {
			activity = this.selectedActivity.copy();
			this.selectedActivity.clearUpdates();
		}
		else {
			activity = this.selectedActivity;
		}
		activity.text = this.activityEditText.value;
		activity.color = this.colourPicker.HEX;
		activity.linkData = this.linkResourceList.getSaveData();
		activity.save();

		if (this.withActivity == UPDATE_EXISTING_EVENT) {
			this.activeInstance.event.swapActivity(activity);
			this.showEventDetails(this.activeInstance);
		} 
		else if (this.withActivity == CREATE_NEW_EVENT) {
			this.activeLayer.newEvent(activity);
		}
	}

	cancelActivity() {
		this.selectedActivity.clearUpdates();

		if (this.withActivity == CREATE_NEW_EVENT) {
			this.activeLayer.clearSelectArea();
		}
	}

	repeatEvent() {
		this.repeatDialog.title = "Repeat Event";
		this.repeatDialog.clear().body = this.activeInstance.event.repeat.form;
		this.repeatDialog.open(
			() => this.activeInstance.event.repeat.apply(),
			() => this.activeInstance.event.repeat.cancel()
		);
	}

	repeatSelection() {
		this.repeatDialog.title = "Repeat Selected Events";
		this.repeatDialog.clear().body = this.selection.first.event.repeat.form;
		this.repeatDialog.open(
			() => {
				this.selection.first.event.repeat.apply();
				this.selection.moveToPosition(0);
				while (this.selection.moveNext()) {
					this.selection.item.event.repeat = this.selection.first.event.repeat.copy(
						this.selection.item.event,
						this.selection.item.rawStartTime
					);
					this.selection.item.event.repeat.save();
					this.selection.item.event.rebuild();
				}
			},
			() => this.selection.first.event.repeat.cancel()
		);
	}

	moveEvent() {
		if (!this.activeInstance) return;
		this.moveCopyDialog.title = 'Move Event';
		this.moveCopyDialog.affirmLabel = _("MOVE");
		this.initCopyMoveDialog(this.activeInstance);
		this.moveCopyDialog.open(() => {
			this.activeInstance.event.moveTo(
				this.startDatePicker.getUTC()
				+ this.startTimePicker.getMillis()
				- this.activeInstance.startTime,
				this.getLayer(this.layerSelect.value)
			);
			this.update();
		});
	}

	moveSelection() {
		if(this.selection.isEmpty) return;
		this.moveCopyDialog.title = 'Move Selected Events';
		this.moveCopyDialog.affirmLabel = _("MOVE");
		this.initCopyMoveDialog(this.selection.first);
		this.moveCopyDialog.open(() => {
			let dTime = this.startDatePicker.getUTC()
				+ this.startTimePicker.getMillis()
				- this.selection.first.startTime;
			this.selection.forEach(inst => inst.event.moveTo(
				dTime,
				this.getLayer(this.layerSelect.value)
			));
			this.update();
		});
	}

	copyEvent() {
		if (!this.activeInstance) return;
		this.moveCopyDialog.title = 'Copy Event';
		this.moveCopyDialog.affirmLabel = _("COPY");
		this.initCopyMoveDialog(this.activeInstance);
		this.moveCopyDialog.open(() => {
			this.activeInstance.event.copyTo(
				this.startDatePicker.getUTC()
				+ this.startTimePicker.getMillis()
				- this.activeInstance.startTime,
				this.getLayer(this.layerSelect.value)
			);
			this.update();
		});
	}

	copySelection() {
		if(this.selection.isEmpty) return;
		this.moveCopyDialog.title = 'Copy Selected Events';
		this.moveCopyDialog.affirmLabel = _("COPY");
		this.initCopyMoveDialog(this.selection.first);
		this.moveCopyDialog.open(() => {
			let dTime = this.startDatePicker.getUTC()
				+ this.startTimePicker.getMillis()
				- this.selection.first.startTime;
			this.selection.forEach(inst => inst.event.copyTo(
				dTime,
				this.getLayer(this.layerSelect.value)
			));
			this.update();
		});
	}

	initCopyMoveDialog (instance) {
		this.startDatePicker.setDate(instance.startTime);
		this.startTimePicker.setTime(instance.startTime);
		this.layerSelect.innerHTML = '';
		this.timelines.items.forEach(tl => {
			let group = this.layerSelect.appendChild(htm('optgroup', null, tl.name));
			tl.layerViews.items.forEach(lv => {
				let opt = option(lv.layer.name, lv.layer.id);
				opt.selected = lv.isActive && lv.layer.isActive;
				opt.disabled = lv.layer.isReadOnly;
				group.appendChild(opt);
			})
		});
	}
	
	deleteSelection () {
		if (this.selection.isEmpty) return;
		this.selection.forEach(inst => inst.event.delete());
		this.clearSelection();
	}

	/* setDuration (val) {
		var startTime = this.startDatePicker.getUTC() + this.startTimePicker.getMillis();
		var endTime = this.endDatePicker.getUTC() + this.endTimePicker.getMillis();
		var duration;
		var moveEnd = false;

		if (typeof(val) === 'undefined' || val === null) {
			duration = endTime - startTime;
		} else {
			duration = val;
			moveEnd = true;
		}

		if (duration < 0) {
			duration = 5 * 60000;
			moveEnd = true;
		}

		if (moveEnd) {
			endTime = startTime + duration;
			this.endDatePicker.setDate(endTime);
			this.endTimePicker.setTime(endTime);
		}

		this.dispDuration(duration);
	} */
	/* dispDuration (duration) {
		var hrs, min, str;
		duration = duration / 60000;
		min = duration % 60;
		hrs = Math.floor(duration / 60);
		str = (hrs) ? hrs + (hrs > 1 ? 'hrs ' : 'hr ') : '';
		str = str + min + (min > 1 ? 'mins' : 'min');
		this.editEventDuration.value = str;
	} */

	onStartTimeChanged() {
		if (!this.activeInstance) return;
		let event = this.activeInstance.event;
		event.startTime = this.startDatePicker.getUTC() + this.startTimePicker.getMillis();
		this.endDatePicker.setDate(event.endTime);
		this.endTimePicker.setTime(event.endTime);
	}

	onEndTimeChanged() {
		if (!this.activeInstance) return;
		let event = this.activeInstance.event;
		event.endTime = this.endDatePicker.getUTC() + this.endTimePicker.getMillis();
		this.startDatePicker.setDate(event.startTime);
		this.startTimePicker.setTime(event.startTime);
	}

	onGroupStartChanged() {
		if (!this.activeGroup) return;
		this.activeGroup.startTime = this.groupStartDatePicker.getUTC() + this.groupStartTimePicker.getMillis();
	}

	openActivitySearchWindow() {
		this.getActivities();
		this.randomColor = [];
		for (let i = 0, ii = 10; i < ii; i++) {
			this.randomColor[i] = this.colourPicker.random().HEX;
		}
		this.activitySearchDialog.open(null, this.cancelActivitySearchWindow.bind(this));
		this.activitySearchText.focus();
		this.activitySearchText.select();
	}

	cancelActivitySearchWindow() {
		if (this.withActivity === CREATE_NEW_EVENT) {
			this.activeLayer.clearSelectArea();
		}
	}

	getActivities() {
		//	called when
		//		user types search text in activity search dialog
		//		and activity search dialog is opened
		if (this.abortController) {
			this.abortController.abort('New search');
		}
		this.abortController = new AbortController();

		API.fetch(
			'activities',
			{
				searchText: this.activitySearchText.value,
				targetLayer: this.activeLayer.id
			},
			this.abortController.signal
		)
		.then(reply => {
			if (reply.abort) return;

			this.activitySearchContainer.innerHTML = '';

			this.isLayerOwner = reply.userOwnsTarget;
			this.activitySearchResult = [];
			let exactMatch;


			if (reply.activities && Array.isArray(reply.activities)) {
				reply.activities.forEach((data) => {
					let activity = Activity.fromArray(data);
					this.activitySearchResult.push(activity);
					this.activitySearchContainer.appendChild(activity.card);
				});
			}

			if (this.activitySearchText.value != '') {
				let i = 0;
				if (reply.graphics && Array.isArray(reply.graphics) && reply.graphics.length) {
					reply.graphics.forEach((data) => {
						exactMatch = false;
						this.activitySearchResult.forEach((existing) => {
							if (
								existing.text.toLowerCase() == this.activitySearchText.value.toLowerCase() &&
								existing.graphicId == data[0]
							) exactMatch = true;
						});
						if (!exactMatch) {
							let activity = Activity.suggest(
								this.activitySearchText.value,
								this.randomColor[i++ % 10],
								data[0]
							);
							this.activitySearchResult.push(activity);
							this.activitySearchContainer.appendChild(activity.card);
						}
						exactMatch = false;
						this.activitySearchResult.forEach((existing) => {
							if (
								existing.text.toLowerCase() == data[1].toLowerCase() &&
								existing.graphicId == data[0]
							) exactMatch = true;
						});
						if (!exactMatch) {
							let activity = Activity.suggest(
								data[1],
								this.randomColor[i++ % 10],
								data[0]
							);
							this.activitySearchResult.push(activity);
							this.activitySearchContainer.appendChild(activity.card);
						}
					});
				}
				else {
					let activity = Activity.suggest(this.activitySearchText.value, this.randomColor[0]);
					this.activitySearchResult.push(activity);
					this.activitySearchContainer.appendChild(activity.card);
				}
			}
		});
	}

	changeActivityGraphic() {
		// called when user clicks on the graphic in the activity edit dialog
		gSearch.start(this.activityEditText.value, this.updateActivityGraphic.bind(this));
	}

	updateActivityGraphic(graphicId) {
		if (graphicId !== null) {
			this.selectedActivity.graphicId = graphicId;
			this.updateActivityPreview();
		}
	}

	updateActivityPreview() {
		if (this.selectedActivity === null) return;

		if (this.selectedActivity.hasGraphic()) {
			this.activityEditGraphic.src = graphicSrc(this.selectedActivity.graphicId, AC.GRAPHIC_MED);
			this.activityGraphicOverlay.className = 'overlay-change-graphic';
		}
		else {
			this.activityEditGraphic.src = '/images/lighten50.png';
			this.activityGraphicOverlay.className = 'overlay-add-graphic';

		}
		this.activityPreview.style.backgroundColor = '#' + this.colourPicker.HEX;
		this.activityPreview.style.color = getContrastColor('#' + this.colourPicker.HEX);
		// this.activityPreviewText.innerText = this.activityEditText.value;
	}

	showEventDetails(instance, force) {
		if (!instance) return;
		if (this.activeInstance && !force) return;

		this.popupName.innerText = instance.event.activity.text;
		if (instance.event.activity.hasGraphic()) {
			this.popupGraphic.style.display = 'inline-block';
			this.popupGraphic.src = graphicSrc(instance.event.graphicId);
		}
		else {
			this.popupGraphic.style.display = 'none';
		}
		this.eventPopup.style.backgroundColor = instance.event.color;
		this.eventPopup.style.color = getContrastColor(instance.event.color);
		this.editActivityButton.disabled = !instance.activity.isEditable;
		this.selectEventChk.checked = instance.selected;
		state(this.popupGroupIcon, instance.event.groupId ? 'norm' : 'hide');
		state(this.popupRepeatIcon, instance.event.repeatId ? 'norm' : 'hide');
		state(this.popupLinkIcon, (instance.event.activity && instance.event.activity.itemCount) ? 'norm' : 'hide');
		state(this.eventPopup);
		this.updateEventDetails(instance);
	}

	hideEventDetails() {
		if (this.activeInstance) return;
		state(this.eventPopup, 'hide');
	}

	updateEventDetails(instance) {
		instance = instance || this.activeInstance;
		if (!instance) return;

		let box = instance.activeView.elem.getBoundingClientRect();
		let tl = this.activeLayer?.activeView?.timeline;

		if (tl?.startTimeDisplay) tl.startTimeDisplay.setTime(instance.startTime);
		if (tl?.endTimeDisplay) tl.endTimeDisplay.setTime(instance.endTime);

		this.eventPopup.style.left =
			limit(box.left + (box.width / 2) - 200, 0, window.innerWidth - 400) + 'px';
		this.eventPopup.style.top = box.top - 105 + 'px';
	}

	deleteEvent() {
		if (!this.activeInstance) return;
		this.activeInstance.event.delete();
	}


	activateInstance(instance) {
		if (this.selection.isNotEmpty) {
			this.selectInstance(instance);
			return false;
		}

		instance = instance || null;

		if (instance === this.activeInstance) return true;
		
		if (this.activeInstance) {
			this.activeInstance.active = false;
		}
		this.activeInstance = instance;
		if (instance) {
			instance.activeView.layerView.activate();
			instance.active = true;
			this.activeLayer.clearMoving();
			this.activeLayer.addMovingEvent(instance.event);
			this.showEventDetails(instance, true);
		}
		this.updateControls();
		return true;
	}

	clearActive () {
		if (this.activeInstance) {
			this.activeInstance.active = false;
		}
		this.activeInstance  = null;
		// this.activeLayer = null;
		this.hideEventDetails();
		this.updateControls();
	}

	selectInstance(instance) {
		if (instance === null) instance = this.activeInstance;
		if (instance === null) return;

		if (instance.event.isRepeated) {
			makeToast(_("Events in repeat set can not be added to selection"));
			return;
		}
		if (this.activeLayer !== instance.event.layer) {
			makeToast(_("Selected event must be on the same layer"));
			return;
		}
		let tl = this.activeLayer?.activeView?.timeline;
		if (this.selection.exists(instance)){
			this.selection.remove(instance);
			this.activeLayer.removeMovingEvent(instance.event);
			if (tl?.groupBar) tl.groupBar.removeChild(instance.pointer);
			instance.selected = false;
			if (this.selection.isEmpty) {
				this.clearSelection();
			}
		} else {
			if (this.selection.isEmpty) {
				this.clearSelection();
				this.activeLayer = instance.event.layer;
				tl = this.activeLayer?.activeView?.timeline;
			}
			instance.selected = true;
			this.selection.add(instance);
			this.activeLayer.addMovingEvent(instance.event);
			if (tl?.groupBar) tl.groupBar.appendChild(instance.pointer);
		}
		this.updateControls();
	}

	clearSelection() {
		let tl = this.activeLayer?.activeView?.timeline;
		this.selection.forEach(inst => {
			if (tl?.groupBar) tl.groupBar.removeChild(inst.pointer);
			inst.selected = false;
		});
		this.selection.init();
		this.selectionMgr.items = this.selection.items;
		this.clearActive();
		this.updateControls();
	}

	setActiveLayer (layer) {
		this.activeLayer = layer;
	}

	goToDate (utc) {
		// send the timeline directly to the utc date
		if (utc == null) return;
		this.centerDatum();
		this.targetTime = (utc);
		document.cookie = 'tl-time=' + this.targetTime;
		this.targetZoomFactor = this.zoomFactor;
        this.startTicker();
	}

	prevWeek () {this.goToDate(this.originTime - MILLISECONDS_PER_DAY * 7);}

	nextWeek () {this.goToDate(this.originTime + MILLISECONDS_PER_DAY * 7);}

	prevDay () {this.goToDate(this.originTime - MILLISECONDS_PER_DAY);}

	nextDay () {this.goToDate(this.originTime + MILLISECONDS_PER_DAY);}

	zoomIn() {
		this.centerDatum();
		this.stepZoom(1);
	}

	zoomOut() {
		this.centerDatum();
		this.stepZoom(-1);
	}

	scrollZoom(cursorTime, cursorFraction, wheelDelta) {
		if (this.zoomPause) return;

		this.zoomPause = setTimeout((function () {
			this.zoomPause = null;
		}).bind(this), 100);

		this.setDatum(cursorTime, cursorFraction);
		this.stepZoom(wheelDelta);
	}

	stepZoom(dir) {
		if (dir < 0) {
			if (ZOOM_FACTORS.length - 1 <= this.zoomPicker.value) return;
			this.zoomPicker.value++;
		} else {
			if (this.zoomPicker.value <= 0) return;
			this.zoomPicker.value--;
		}
		this.zoom();
	}

	selectZoom() {
		this.centerDatum();
		this.zoom();
	}
	
	zoom() {
		this.targetTime = this.originTime;
		this.targetZoomFactor = ZOOM_FACTORS[this.zoomPicker.value].value;
		document.cookie = 'tl-zoom=' + this.zoomPicker.value;
        this.startTicker();
	}

	setStopDist() {
		// stop distance s = 1/2 at^2 where time = change in speed / acceleration
		var dv = this.pixelsToMilliseconds(this.panVelocity);
		var a = this.pixelsToMilliseconds(PANNING_DECELERATION);
		this.panStopDist = ((dv / 2) * (dv / a));
	}

	startTicker() {
		if (this._ticker === null) this._ticker = setInterval(this.tick.bind(this), 20);
	}

	tick() {
		if (this._skipTick) return;
		
		this._skipTick = true;
		
        if (this.zoomFactor === this.targetZoomFactor && this.originTime === this.targetTime) {
			clearInterval(this._ticker);
			this._ticker = null;
			this.getTimelineData();
			this._skipTick = false;
            return;
        }
		// update velocity, datum, scale and position elements
		var direction = Math.sign(this.targetTime - this.originTime);
		var distance = Math.abs(this.originTime - this.targetTime);
		var zoomDiff;

		if (Math.sign(this.panVelocity) === direction) {
			// travelling in right direction
			if (distance < this.panStopDist * 1.2 && Math.abs(this.panVelocity) > MIN_PANNING_VELOCITY) {
				// above min speed then slow and near stopping distance -> slow down
				this.panVelocity -= PANNING_DECELERATION * direction;
				this.setStopDist();
			}
			else if (distance > this.panStopDist * 2) {
				if (Math.abs(this.panVelocity) < MAX_PANNING_VELOCITY) {
					this.panVelocity += PANNING_ACCELERATION * direction;
					this.setStopDist();
				}
				else {
					// jump ahead
					this.originTime = this.targetTime - (this.panStopDist * 2 * direction);
				}
			}
		}
		else {
			// moving away from target -> accelerated towards it
			this.panVelocity += PANNING_ACCELERATION * direction;
			this.setStopDist();
		}

		if (distance < Math.abs(this.pixelsToMilliseconds(this.panVelocity))) {
			// would pass on next step
			this.originTime = this.targetTime;
			this.panVelocity = 0;
			this.panStopDist = 0;
		}
		else this.originTime += this.pixelsToMilliseconds(this.panVelocity);

		if (this.zoomFactor !== this.targetZoomFactor) {
			if (this.targetZoomFactor < this.zoomFactor){
				zoomDiff = this.zoomFactor - this.targetZoomFactor;
				if (zoomDiff < 0.25) {
					this.zoomFactor = this.targetZoomFactor;
				}
				else{
					this.zoomFactor -= zoomDiff * 0.3;
				}
			}
			if (this.targetZoomFactor > this.zoomFactor) {
				zoomDiff = this.targetZoomFactor - this.zoomFactor;
				if (zoomDiff < 0.25) {
					this.zoomFactor = this.targetZoomFactor;
				}
				else {
					this.zoomFactor += zoomDiff * 0.3;
				}
			}
			this.onScaleChange();
		} else {
			this.update();
		}
		this._skipTick = false;
	}

	onScaleChange () {
		if (this.lastWidth) {
			this.millisecondPerPixel = this.getDaysInView() * MILLISECONDS_PER_DAY / this.lastWidth;
		}
		this.timelines.forEach(timeline => timeline.scaleChange());
		this._layers.forEach((layer) => {
			layer.onScaleChange();
		})
		this.update()
	}

	update() {
		let totalMs = this.getDaysInView() * MILLISECONDS_PER_DAY;
		this.gotoDatePicker.setDate(this.viewStartMilliseconds + totalMs / 2);
		this.timelines.forEach((timeline) => {
			timeline.update();
		});
		this._layers.forEach((layer) => {
			layer.update();
		})
		this.updateEventDetails();
		this.updateControls();
	}

	updateControls () {
		this.selectionMgr.update();

		if (this.activeInstance) {
			let tl = this.activeLayer?.activeView?.timeline;
			if (tl) tl.updateControls();
		} else {
			this.timelines.forEach(tl => tl.updateControls());
		}
	}

	getDaysInView () {
		return Math.pow(this.zoomFactor, 4) / 20000;
	}

	panScroll (ev) {
		stopEv(ev);
		ev.preventDefault();
		if (this.zoomPause) return;
		this.zoomPause = setTimeout((function () {
			this.zoomPause = null;
		}).bind(this), 50);
		var dir = 0;
		if (ev.detail) {
			dir = (ev.detail < 0) ? 1 : -1;
		} else {
			dir = (ev.wheelDelta < 0) ? -1 : 1;
		}
		this.targetTime += this.pixelsToMilliseconds(100 * dir);
		this.startTicker();
	}

	getDatum () {
		return this.originTime;
	}

	setDatum (time, fraction) {
		this.originTime = time;
		this.datumFraction = (typeof fraction === 'undefined') ? 0.5 : fraction;
	}

	centerDatum () {
		let totalMs = this.getDaysInView() * MILLISECONDS_PER_DAY;
		this.originTime = this.viewStartMilliseconds + totalMs / 2;
		this.datumFraction = 0.5;
	}

	resize () {
		if (this.resizing || !this._elem) return;
		if (this.lastWidth === this._elem.offsetWidth) return;
		this.lastWidth = this._elem.offsetWidth;
		if (this.lastWidth) {
			this.millisecondPerPixel = this.getDaysInView() * MILLISECONDS_PER_DAY / this.lastWidth;
		}
	}
	
	timeToOffset(utc) {
		if (this.timelines.isNotEmpty) return this.timelines.first.timeToOffset(utc);
		return Math.floor(((utc - this.viewStartMilliseconds) / this.millisecondPerPixel));
	}

	offsetToTime(offset) {
		if (this.timelines.isNotEmpty) return this.timelines.first.offsetToTime(offset);
		return this.viewStartMilliseconds + (offset * this.millisecondPerPixel);
	}

	millisecsToPixels(millis) {
		if (this.timelines.isNotEmpty) return this.timelines.first.millisecsToPixels(millis);
		return Math.floor(millis / this.millisecondPerPixel);
	}

	pixelsToMilliseconds(px, snap) {
		if (this.timelines.isNotEmpty) return this.timelines.first.pixelsToMilliseconds(px, snap);
		if (snap) return Math.round((px * this.millisecondPerPixel) / snap) * snap;
		return Math.round(px * this.millisecondPerPixel);
	}

	refreshData() {
		if (this._timelinesElem) {
			this._timelinesElem.innerHTML = '';
			if (this.timelines.isNotEmpty) this.timelines.first.controls.remove();
		}
		this.timelines.clear();
		this._layerIds = [];
		this._layers = [];
		this._eventIds = [];
		this._events = [];
		this.memoryTimeA = this.memoryTimeB = this.viewStartMilliseconds - DOWNLOAD_BUFFER;
		this.getTimelineData();
	}

	getTimelineData () {
		let getDetails, fromTime, toTime;
		if (this.viewStartMilliseconds < this.memoryTimeA + DOWNLOAD_TRIGGER_MARGIN) {
			getDetails = this.memoryTimeA === this.memoryTimeB ? 1 : 0;
			fromTime = (this.viewStartMilliseconds - DOWNLOAD_BUFFER) / 1000;
			toTime = (this.viewEndMilliseconds + DOWNLOAD_BUFFER < this.memoryTimeA
				? this.viewEndMilliseconds + DOWNLOAD_BUFFER
				: this.memoryTimeA) / 1000;
		}
		else if (this.memoryTimeB - DOWNLOAD_TRIGGER_MARGIN < this.viewEndMilliseconds) {
			getDetails = this.memoryTimeA === this.memoryTimeB ? 1 : 0;
			fromTime = (this.memoryTimeB < this.viewStartMilliseconds - DOWNLOAD_BUFFER
					? this.viewStartMilliseconds - DOWNLOAD_BUFFER
					: this.memoryTimeB) / 1000;
			toTime = (this.viewEndMilliseconds + DOWNLOAD_BUFFER) / 1000;
		}
		else return;
		
		API.fetch('timelines', {
			getDetails: getDetails,
			fromTime: fromTime,
			toTime: toTime,
			ids: this._timelineIds.length ? this._timelineIds.join(',') : '',
			all: this.display == Timeline.INVISIBLE ? 1 : 0
		})
		.then(data => {
			if (!data || data.error) return;
			this.loadTimelineData(data);
			document.dispatchEvent(new Event('primaryDataLoaded'));
		});
	}

	loadTimelineData (reply) {
		var updateMemTimeA = (reply.reqTimeA * 1000 < this.memoryTimeA || this.memoryTimeB < reply.reqTimeA * 1000);
		var updateMemTimeB = (reply.reqTimeB * 1000 < this.memoryTimeA || this.memoryTimeB < reply.reqTimeB * 1000);

		if (updateMemTimeA) this.memoryTimeA = reply.reqTimeA * 1000;
		if (updateMemTimeB) this.memoryTimeB = reply.reqTimeB * 1000;

		if (reply.layers && Array.isArray(reply.layers)) {
			for (let layerData of reply.layers) {
				let layer = typeof(layerData.details) == 'object'
					? this.addLayer(Layer.fromArray(layerData.details, reply.owner))
					: this.getLayer(layerData.details);

				for (let eventData of layerData.events) {
					this.addEvent(TimelineEvent.fromArray(layer, eventData)).build();
				}
				layer.instances.updateInView(this.viewStartMilliseconds, this.viewEndMilliseconds);
			}
		}

		if (reply.timelines && Array.isArray(reply.timelines)) {
			for (let data of reply.timelines) {
				let timeline = typeof(data.details) == 'object'
					? this.addTimeline(data.details, data.owner)
					: this.getTimelineById(data.details);
				timeline.loadData(data);
			};
		}

		if (reply.sharing_summary && typeof layerSharing !== 'undefined') {
			for (let s of reply.sharing_summary) {
				layerSharing.setCount(parseInt(s.id), parseInt(s.share_count));
			}
		}

		if (reply.access_summary && typeof layerAccess !== 'undefined') {
			for (let s of reply.access_summary) {
				layerAccess.setSummary(parseInt(s.id), parseInt(s.view_count), parseInt(s.edit_count), reply.unit_count);
			}
		}

		this.activities.getData();

		if (this._elem) state(this._elem);
		this.update();
		this.getTimelineData();
	}

	communityLayers () {
		manageLayers.open(this.timelines.first);
	}

	addTimeline (data, owner) {
		let timeline = Timeline.fromArray(data, this);
		timeline.setWidth(this.lastWidth);
		this.timelines.addItem(timeline);

		if (this._onTimelineAdded) {
			this._onTimelineAdded(timeline);
		}

		return timeline;
	}

	getTimelineById(id) {
		for (let timeline of this.timelines.items) {
			if (timeline.id == id) return timeline;
		}
		return null;
	}

	/**
	 * Add new layer to the timeline.
	 * Only for situations where only one timeline in the list. Fail on the dashboard page.
	 */
	newLayer() {
		if (this.timelines.length != 1) return;

		let newLayer = new Layer(this.timelines.first);
		newLayer.name = _("New layer");
		newLayer.openRename();
	}

	addLayer (layer) {
		let i = this._layerIds.indexOf(parseInt(layer.id));
		if (i === -1) {
			this._layers.push(layer);
			this._layerIds.push(layer.id);
		}
		else {
			this._layers.splice(i, 1, layer);
			this._layerIds.splice(i, 1, layer.id);
		}
		return layer;
	}

	getLayer (id) {
		let i = this._layerIds.indexOf(parseInt(id));
		if (i === -1) return null;
		return this._layers[i];
	}
	
	removeLayer (id) {
		let i = this._layerIds.indexOf(id);
		if (i === -1) return;
		this._layerIds.splice(i, 1);
		this._layers.splice(i, 1);
	}

	addEvent(tlEvent) {
		if (!tlEvent.id) return tlEvent;
		
		let i = this._eventIds.indexOf(tlEvent.id);
		if (i !== -1) return this._events[i];

		this._eventIds.push(tlEvent.id);
		this._events.push(tlEvent);
		return tlEvent;
	}

	removeEvent (tlEvent){
		if (!tlEvent || !tlEvent.id) return;

		tlEvent.withActiveInstances(inst => tlEvent.layer.removeEventInstance(inst));
		tlEvent.activity.removeEvent(tlEvent);
		this.clearActive();

		let i = this._eventIds.indexOf(tlEvent.id);
		if (i == -1) return;
		this._events.splice(i, 1);
		this._eventIds.splice(i, 1);
    }

	findEvent(eventId) {
		let i = this._eventIds.indexOf(eventId);
		return i === -1 ? false : this._events[i];
	}
}
